export const ALERTAS_GENERICAS = {
  CAMPOS_REQUERIDOS: "Favor completar los campos requeridos.",
  CAMPO_REQUERIDO: "Este campo es requerido",
  CORREO_INVALIDO: "Ingresa un correo electrónico válido",
  TELEFONO_INVALIDO: "Ingrese un teléfono válido",
  FECHA_DESDE_HASTA_INVALIDA: "La fecha desde debe ser menor que la fecha hasta.",
  SESION_ACTIVA: "Usted ya tiene una sesión activa con el pss: ",
  MEDICO_PRESCRIPTOR_REQUERIDO: "El campo Médico Prescriptor es requerido.",
  MEDICO_PRESCRIPTOR_MIN_CARACTERES: "El nombre del Médico Prescriptor debe contener al menos 5 caracteres.",
  MEDICO_PRESCRIPTOR_SOLO_LETRAS: "El campo Médico Prescriptor solo debe contener letras.",
};
